import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import HeaderContainer from '../../../containers/common/HeaderContainer';
import Navigation from '../../../components/common/Navigation';
import TabMenu from '../../../components/configuration/TabMenu';
import { SideSpacer } from '../../../components/common/Spacer';
import {
  CommonContainer,
  HistoryBlock,
  NoClickHistory,
} from '../../../components/common/Container';
import palette from '../../../lib/styles/palette';
import QRCode from 'qrcode.react';
import { useHistory } from 'react-router-dom';
import { encodeClubID } from '../../../lib/clubIdCipher';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
`;

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
`;

const Desc = styled.div`
  font-size: .85rem;
  color: #888;
  margin-bottom: 24px;
`;

const QRWrap = styled.div`
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const LinkText = styled.div`
  font-size: .8rem;
  color: #aaa;
  margin-bottom: 24px;
  word-break: break-all;
  text-align: center;
  max-width: 280px;
`;

const BtnRow = styled.div`
  display: flex;
  gap: 10px;
  width: 280px;
`;

const Btn = styled.button`
  flex: 1;
  padding: 10px 0;
  border-radius: 8px;
  font-size: .9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
`;

const BtnOpen = styled(Btn)`
  background: ${palette.webCyan[5]};
  color: #fff;

  &:hover {
    opacity: 0.85;
  }
`;

const AttendAppPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  let history = useHistory();

  const { club } = useSelector(({ club }) => ({
    club: club.defaultClub,
  }));

  const kioskURL = club && club.clubID ? `${window.location.origin}/attendmanager/${encodeClubID(club.clubID)}` : '';

  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer>
          <HistoryBlock>
            <NoClickHistory>설정</NoClickHistory>
          </HistoryBlock>
          <TabMenu underbar={true} />
          <Wrap>
            {/* <Title>출석앱</Title> */}
            <Desc>QR코드를 스캔하여 출석앱 화면을 열 수 있습니다.</Desc>
            <QRWrap>
              <QRCode value={kioskURL} size={180} />
            </QRWrap>
            <LinkText>{kioskURL}</LinkText>
            <BtnRow>
              <BtnOpen onClick={() => window.open(kioskURL, '_blank')}>
                바로열기
              </BtnOpen>
            </BtnRow>
          </Wrap>
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default AttendAppPage;
